document.addEventListener("DOMContentLoaded", function () {

  const productIdsHandled = new Set();

  let lastRemovedItems = [];



  function isTargetItem(item) {

    const suffix = item?.properties?.template_suffix?.toLowerCase?.();

    return suffix === "bundled" || suffix === "build-your-own";

  }



  function isLimitedToSingleQty(product) {

    //return product?.tags?.includes("Limited") || false;

    // return product?.tags?.includes("bundleqty_3") || false;

    return product?.tags?.map(t => t.toLowerCase()).includes("limited_bundle_one_per_cart") || false;

  }



  function getBundleQty(product) {

    const tag = product?.tags?.find((t) => t.startsWith("bundleqty_"));

    const qty = parseInt(tag?.split("_")[1], 10);

    return isNaN(qty) ? 3 : qty;

  }



  function showFeedbackMessage(productTitle, requiredQty,isLimitedToSingleInCart) {

    const existing = document.querySelector(".bundle-feedback");

    if (existing) existing.remove();



    const div = document.createElement("div");

    div.className = "bundle-feedback";

    div.style = `
      position: fixed; top: 20px; right: 20px; background: #333; color: white;
      padding: 20px; border-radius: 8px; z-index: 99999999999; box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      max-width: 480px; font-size: 14px; line-height: 1.4;
    `;



    if(isLimitedToSingleInCart){

      var messageHTML = `The bundle "<strong>${productTitle}</strong>" is incomplete or not in a valid quantity (must be a maximum of ${requiredQty} items) and was removed.`

    }

    else{

      var messageHTML = `The bundle "<strong>${productTitle}</strong>" is incomplete or not in a valid quantity (must be in multiples of ${requiredQty}, e.g. ${requiredQty}, ${
      requiredQty * 2
      }, ${requiredQty * 3}, etc) and was removed.`

    }



    div.innerHTML = `
      <button id="close-feedback" style="
        position: absolute; top: 8px; right: 10px; background: transparent;
        border: none; color: white; font-size: 18px; cursor: pointer;">&times;</button>
      <div style="margin-right: 24px; margin-top: 8px;">
        ${messageHTML}
        <div style="margin-top: 12px;">
          <button id="undo-bundle" style="
            background: #999; color: #333; border: none; padding: 6px 12px;
            border-radius: 4px; cursor: not-allowed;" disabled>Undo</button>
        </div>
      </div>
      <style>@media (max-width: 480px) {.bundle-feedback{left:20px;}}</style>
    `;

    document.body.appendChild(div);



    div
      .querySelector("#close-feedback")
      .addEventListener("click", () => div.remove());

    return div;

  }



  function calculateTotalQuantity(cart, productId) {

    return cart.items
      .filter((i) => i.product_id === productId && isTargetItem(i))
      .reduce((sum, i) => sum + i.quantity, 0);

  }



  function removeAllMatchingVariants(referenceItem, requiredQty = 3,isLimitedToSingleInCart = false) {

    const productId = referenceItem.product_id;

    if (productIdsHandled.has(productId)) return;

    productIdsHandled.add(productId);



    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {

        const updates = {};

        const removed = [
          {
            variant_id: referenceItem.variant_id,
            quantity: referenceItem.quantity,
            properties: referenceItem.properties || {},
          },
        ];

        let productTitle = referenceItem.product_title || referenceItem.title;



        cart.items.forEach((item) => {

          if (item.product_id === productId && isTargetItem(item)) {

            updates[item.key] = 0;

            if (item.variant_id !== referenceItem.variant_id) {

              removed.push({
                variant_id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties || {},
              });

            }

            if (!productTitle && item.product_title)
              productTitle = item.product_title;

          }

        });



        if (Object.keys(updates).length === 0) return;



        let feedbackDiv = null;
        let undoButton = null;

        if (window.location.pathname !== "/cart") {

          feedbackDiv = showFeedbackMessage(productTitle, requiredQty,isLimitedToSingleInCart);
          undoButton = feedbackDiv.querySelector("#undo-bundle");

        }



        fetch("/cart/update.js", {

          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),

        }).then(() => {

          if (undoButton) {

            lastRemovedItems = removed;
            undoButton.disabled = false;
            undoButton.style.cursor = "pointer";
            undoButton.style.background = "#7b9a62";
            undoButton.style.color = "#ffffff";



            undoButton.addEventListener("click", function () {

              const sanitizedItems = lastRemovedItems
                .filter((item) => item.variant_id && item.quantity)
                .map((item) => ({
                  id: item.variant_id,
                  quantity: item.quantity,
                  ...(item.properties && Object.keys(item.properties).length > 0
                    ? { properties: item.properties }
                    : {}),
                }));



              fetch("/cart/add.js", {

                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: sanitizedItems }),

              })
                .then((res) => {

                  if (!res.ok) {

                    return res.text().then((text) => {
                      throw new Error(text);
                    });

                  }

                  return res.json();

                })
                .then(() => {

                  feedbackDiv.remove();



                  if (window.location.pathname === "/cart") {

                    location.reload();

                  } else if (window.Rebuy?.SmartCart?.render) {

                    Rebuy.SmartCart.render();

                  }

                })
                .catch((err) => {

                  alert("Failed to re-add bundle: " + err.message);
                  console.error("Cart add error:", err);

                });

            });



            setTimeout(() => feedbackDiv.remove(), 12000);

          }



          if (window.location.pathname === "/cart") {

            location.reload();

          }

        });

      });



    setTimeout(() => productIdsHandled.delete(productId), 5000);

  }



  function validateAndRemoveIfNeeded(referenceItem, product) {

    const requiredQty = getBundleQty(product);
    const isLimitedToSingleInCart = isLimitedToSingleQty(product);



    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {

        const totalQty = calculateTotalQuantity(cart, referenceItem.product_id);



        if(isLimitedToSingleInCart != true){

          if (totalQty !== requiredQty && totalQty % requiredQty !== 0) {

            removeAllMatchingVariants(referenceItem, requiredQty, false);

          }

        }

        else{

          if (totalQty > requiredQty) {

            removeAllMatchingVariants(referenceItem, requiredQty, true);

          }

          else if (totalQty < requiredQty || totalQty % requiredQty !== 0) {

            removeAllMatchingVariants(referenceItem, requiredQty, true);

          }

        }

      });

  }



  [
    "rebuy:smartcart.line-item-decrease",
    "rebuy:smartcart.line-item-increase",
    "rebuy:smartcart.line-item-removed",
  ].forEach((eventName) => {

    document.addEventListener(eventName, function (event) {

      const item = event.detail.item;

      if (!item || !isTargetItem(item)) return;
      if (productIdsHandled.has(item.product_id)) return;



      fetch(`/products/${item.handle}.js`)
        .then((res) => res.json())
        .then((product) => {

          setTimeout(() => {

            validateAndRemoveIfNeeded(item, product);

          }, 250);

        });

    });

  });



  async function getItemFromDOM(row) {

    const quantityInput = row.querySelector("input.quantity__input");
    const variantId = quantityInput?.dataset.quantityVariantId;
    const quantity = parseInt(quantityInput?.value, 10);

    const productHandle = row
      .querySelector("a.cart-item__name")
      ?.getAttribute("href")
      ?.split("/products/")[1]
      ?.split("?")[0];



    if (!variantId || !productHandle) return null;



    const properties = {};

    const dl = row.querySelector("dl");

    if (dl) {

      const dtElements = dl.querySelectorAll("dt");
      const ddElements = dl.querySelectorAll("dd");

      for (let i = 0; i < dtElements.length; i++) {

        const key = dtElements[i].textContent.trim().toLowerCase();
        const value = ddElements[i].textContent.trim();

        if (key && value) {

          properties[key] = value;

        }

      }

    }



    const product_return = await fetch(`/products/${productHandle}.js`).then(
      (res) => res.json()
    );

    return {

      variant_id: parseInt(variantId, 10),
      handle: productHandle,
      product_id: product_return.id,
      quantity,
      properties,

    };

  }



  function handleCartPageQuantityEvents() {

    document
      .querySelectorAll(".quantity__button, .cart-item__quantity input")
      .forEach((buttonOrInput) => {

        buttonOrInput.addEventListener("change", onCartQuantityChange);

        buttonOrInput.addEventListener("click", () =>
          setTimeout(onCartQuantityChange, 250)
        );

      });



    document.querySelectorAll("cart-remove-button a").forEach((link) => {

      link.addEventListener("click", async (e) => {

        const row = e.target.closest("tr.cart-item");
        const item = await getItemFromDOM(row);



        if (item) {

          e.preventDefault();

          const product = await fetch(`/products/${item.handle}.js`).then(
            (res) => res.json()
          );

          validateAndRemoveIfNeeded(item, product);

        }

      });

    });

  }



  async function onCartQuantityChange() {

    const rows = document.querySelectorAll("tr.cart-item");



    for (const row of rows) {

      const item = await getItemFromDOM(row);



      if (item) {

        try {

          const res = await fetch(`/products/${item.handle}.js`);
          const product = await res.json();

          await validateAndRemoveIfNeeded(item, product);

        } catch (error) {

          console.error("Error fetching product or validating:", error);

        }

      }

    }

  }



  handleCartPageQuantityEvents();



  function showBundleLimitMessage(productTitle, maxQty) {

    const existing = document.querySelector(".bundle-feedback");

    if (existing) existing.remove();



    const div = document.createElement("div");

    div.className = "bundle-feedback";

    div.style = `
      position: fixed; top: 20px; right: 20px; background: #c0392b; color: white;
      padding: 20px; border-radius: 8px; z-index: 99999999999; box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      max-width: 480px; font-size: 14px; line-height: 1.4;
    `;

    div.innerHTML = `
      <button id="close-feedback" style="
        position: absolute; top: 8px; right: 10px; background: transparent;
        border: none; color: white; font-size: 18px; cursor: pointer;">&times;</button>

      <div style="margin-right: 24px; margin-top: 8px;">
        <strong>Limit Reached</strong><br>
        You may only have <strong>${maxQty}</strong> of "${productTitle}" in your cart.

        <div style="margin-top: 12px;">
          <button id="undo-bundle" style="
            background: #fff; color: #333; border: none; padding: 6px 12px;
            border-radius: 4px; cursor: pointer;">Close</button>
        </div>
      </div>

      <style>
        @media (max-width: 480px) {
          .bundle-feedback {
            left: 20px;
          }
        }
      </style>
    `;

    div.querySelectorAll("button").forEach(elem => elem.addEventListener("click", () => {

      div.remove();

    }));

    document.body.appendChild(div);

    setTimeout(() => div.remove(), 8000);

  }



  document.addEventListener('rebuy:cart.add', function(event) {

    let addedItems = event.detail.item;

    if(!("items" in addedItems)){

      addedItems = [addedItems];

    }

    else{

      addedItems = addedItems.items;

    }



    addedItems.forEach(addedItem => {

      const productId = addedItem.product_id;



      fetch(`/products/${addedItem.handle}.js`)
        .then(res => res.json())
        .then(product => {

          const tags = product.tags?.map(t => t.toLowerCase()) || [];
          const isLimited = tags.includes('limited_bundle_one_per_cart');

          if (!isLimited) return;



          const qtyTag = tags.find(t => t.startsWith('bundleqty_'));

          let maxQty = parseInt(qtyTag?.split('_')[1], 10);

          if (isNaN(maxQty)) maxQty = 1;



          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {

              const currentQty = cart.items
                .filter(item => item.product_id === productId)
                .reduce((sum, item) => sum + item.quantity, 0);



              if (currentQty > maxQty) {

                const updates = {};

                let toRemove = currentQty - maxQty;



                for (const item of cart.items.filter(i => i.product_id === productId)) {

                  if (toRemove <= 0) break;

                  const removeQty = Math.min(item.quantity, toRemove);

                  updates[item.key] = item.quantity - removeQty;

                  toRemove -= removeQty;

                }



                showBundleLimitMessage(product.title, maxQty);



                fetch('/cart/update.js', {

                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates })

                }).then(() => {

                  if (window.location.pathname === '/cart') {

                    location.reload();

                  } else if (window.Rebuy?.SmartCart?.render) {

                    Rebuy.SmartCart.render();

                  }

                });

              }

            });

        });

    });

  });



  // Prevent adding more than maxQty when clicking .bundle_add_to_cart

  document.addEventListener('click', function(e) {

    const btn = e.target.closest('.bundle_add_to_cart');

    if (!btn) return;



    e.preventDefault();



    const handle = btn.dataset.handle;
    const productId = parseInt(btn.dataset.productId, 10);



    if (!handle && !productId) {

      console.warn("Button missing data-handle or data-product-id");

      return;

    }



    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {

        const tags = product.tags?.map(t => t.toLowerCase()) || [];

        const isLimited = tags.includes('limited_bundle_one_per_cart');



        if (!isLimited) {

          btn.closest('form')?.requestSubmit(btn);

          return;

        }



        const qtyTag = tags.find(t => t.startsWith('bundleqty_'));

        let maxQty = parseInt(qtyTag?.split('_')[1], 10);

        if (isNaN(maxQty)) maxQty = 1;



        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {

            const currentQty = cart.items
              .filter(i => i.product_id === product.id)
              .reduce((sum, i) => sum + i.quantity, 0);



            if (currentQty >= maxQty) {

              showBundleLimitMessage(product.title, maxQty);

              return;

            }



            btn.removeAttribute('disabled');

            btn.closest('form')?.requestSubmit(btn);

          });

      })
      .catch(err => console.error(err));

  });

});